import { useContext } from 'react';

import { type Feature } from './featureFlags';
import { FeatureFlagsContext } from './FeatureFlagsContext';

export const useFeatureFlag = (feature: Feature): boolean => {
    const context = useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error('useFeatureFlag must be used within a FeatureFlagProvider');
    }
    return context.isFeatureEnabled(feature);
};

export const useFeatureFlagsContext = () => {
    const context = useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error('useFeatureFlagContext must be used within a FeatureFlagProvider');
    }
    return context;
};
